import { $convertToMarkdownString, TRANSFORMERS } from '@lexical/markdown';
import { EditorState } from 'lexical';

export const stateToMarkdown = (state: EditorState) =>
  state.read(() => $convertToMarkdownString(TRANSFORMERS, undefined, true));
